// Need to import these otherwise CSS isn't there
import "stream-chat-react/dist/css/index.css";
import "./ChatList.css";
import { ChatListCommon } from "components/Chat/ChatListCommon";

export const ChatList = ChatListCommon;
